/**
 * @fileoverview GET handler for the "/internal_user_groups/test_user_app_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsTestUserAppData } from "./constants";
import type { AppSettingsInternalUserGroupsTestUserAppDataResult } from "./types";
import { isAppSettingsInternalUserGroupsTestUserAppDataResult } from "./validators";

export const getAppSettingsInternalUserGroupsTestUserAppData = reactQueryFetcherAdapter(
  appSettingsInternalUserGroupsTestUserAppData,
  (signal: AbortSignal, appGroupId: string): Promise<AppSettingsInternalUserGroupsTestUserAppDataResult> => {
    return fetch("/internal_user_groups/test_user_app_data", "GET", { app_group_id: appGroupId }, { signal });
  },
  isAppSettingsInternalUserGroupsTestUserAppDataResult
);
